module.exports = __webpack_public_path__ + "static/media/panel_fin_left.acc23f07.png";